<template>
    <div class="support-button">
        <button @click.prevent="openCalendar" class="button is-primary" v-text="button"></button>
        <popup-calendar @closing="closeModal" :open="calendar" :employee="employee"></popup-calendar>
    </div>
</template>

<script>
    export default {
        props: {
            button: {
                type: String,
                required: true
            },
            employee: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                calendar: false
            }
        },
        methods: {
            openCalendar() {
                this.calendar = true
            },
            closeModal() {
                this.calendar = false
            }
        }
    }
</script>
